<template>
  <div class="minePage">
    <!-- 个人信息 start -->
    <div class="clumn_wrap">
      <div class="tit">
        个人信息
        <span @click="handleShowDialog(1)"
          ><i class="iconfont icon-bianji1"></i
        ></span>
      </div>
      <div class="clumn_main_wrap">
        <el-descriptions title="">
          <el-descriptions-item label="姓名">{{
            userInfo.truename ? userInfo.truename : userInfo.username
          }}</el-descriptions-item>
          <el-descriptions-item label="用户email">{{
            userInfo.email
          }}</el-descriptions-item>
          <el-descriptions-item label="用户属性">{{
            userInfo.userattr
          }}</el-descriptions-item>
          <el-descriptions-item label="企业名称">{{
            userInfo.qyname
          }}</el-descriptions-item>
        </el-descriptions>
      </div>

      <!-- 个人信息编辑 start -->
      <el-dialog
        title="个人信息编辑"
        :visible.sync="dialogUserEdit"
        :close-on-click-modal="false"
        @close="handleCloseDialog(1)"
      >
        <div class="el-dialog-div">
          <el-form
            :model="formDateUserEdit"
            label-position="top"
            ref="formDateUserEdit"
            :rules="ruleFormDateUserEdit"
          >
            <el-form-item label="姓名" prop="truename">
              <el-input
                v-model="formDateUserEdit.truename"
                placeholder="请输入用户"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户email" prop="email">
              <el-input
                v-model="formDateUserEdit.email"
                placeholder="请输入用户email"
              ></el-input>
            </el-form-item>
            <el-form-item label="用户属性" prop="userattr">
              <el-radio-group v-model="formDateUserEdit.userattr">
                <el-radio label="个人合作"></el-radio>
                <el-radio label="企业or机构合作"></el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item label="企业名称" prop="qyname">
              <el-input
                v-model="formDateUserEdit.qyname"
                placeholder="请输入企业名称"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="handleCloseDialog(1)"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="handleUserEdit('formDateUserEdit')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 个人信息编辑 end -->
    </div>
    <!-- 个人信息 end -->

    <!-- 企业信息 start -->
    <div class="clumn_wrap">
      <div class="tit">
        企业信息
        <span
          @click="handleShowDialog(2)"
          v-if="userCompanyCard.checkrole == '创建人'"
          ><i class="iconfont icon-bianji1"></i
        ></span>
      </div>
      <div v-if="userCompanyCard.id && isLoad">
        <template v-if="userCompanyCard.checkstate == '审核中'">
          <div class="operation flex-rowl">
            <el-button type="primary" plain @click="handleGo(2)"
              >企业申请加入中</el-button
            >
          </div>
        </template>
        <template v-else>
          <div class="clumn_main_wrap">
            <el-descriptions title="">
              <el-descriptions-item label="企业名称">{{
                userCompanyCard.qyname
              }}</el-descriptions-item>
              <el-descriptions-item label="企业名称英文/缩写">{{
                userCompanyCard.qyename
              }}</el-descriptions-item>
              <el-descriptions-item label="企业成员邀请码">
                <div class="copy_wrap">
                  {{ userCompanyCard.guid }}
                  <span
                    class="copy_box"
                    :data-clipboard-text="userCompanyCard.guid"
                    @click="handleCopyBtn"
                    ><i class="iconfont icon-fuzhi"></i
                  ></span>
                </div>
              </el-descriptions-item>
              <el-descriptions-item label="联系人">{{
                userCompanyCard.linkname
              }}</el-descriptions-item>
              <el-descriptions-item label="联系电话">{{
                userCompanyCard.linkphone
              }}</el-descriptions-item>
              <el-descriptions-item label="联系邮箱">{{
                userCompanyCard.linkemail
              }}</el-descriptions-item>
              <el-descriptions-item label="社会统一信用代码">{{
                userCompanyCard.uscc
              }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="">
              <el-descriptions-item label="官方抖音ID">{{
                userCompanyCard.douyinid
              }}</el-descriptions-item>
              <el-descriptions-item label="官方小红书ID">{{
                userCompanyCard.redbookid
              }}</el-descriptions-item>
              <el-descriptions-item label="官方大众点评ID">{{
                userCompanyCard.dianpingid
              }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="">
              <el-descriptions-item label="所在地区"
                >{{ userCompanyCard.provincename }}{{ userCompanyCard.cityname
                }}{{ userCompanyCard.arearname }}</el-descriptions-item
              >
              <el-descriptions-item label="详细地址">{{
                userCompanyCard.addr
              }}</el-descriptions-item>
            </el-descriptions>
            <el-descriptions title="">
              <el-descriptions-item label="关联小程序APPID">{{
                userCompanyCard.smallpid
              }}</el-descriptions-item>
            </el-descriptions>
            <div style="margin: 40px 0 30px">
              <div class="tit">你的职务&角色信息</div>
              <el-descriptions title="">
                <el-descriptions-item label="所属部门">{{
                  userCompanyCard.deptname
                }}</el-descriptions-item>
                <el-descriptions-item label="角色类型">{{
                  userCompanyCard.checkrole
                }}</el-descriptions-item>
                <el-descriptions-item label="角色关系">{{
                  userCompanyCard.rolename
                }}</el-descriptions-item>
              </el-descriptions>
            </div>
            <div v-if="false">
              <template
                v-if="
                  userCompanyCard.roleid == 1 ||
                  userCompanyCard.roleid == 32 ||
                  userCompanyCard.roleid == 33 ||
                  userCompanyCard.roleid == 34 ||
                  userCompanyCard.roleid == 35
                "
              >
                <el-button type="primary" @click="handleShowDialog(2)"
                  >企业/团队信息管理</el-button
                >
                <el-button type="primary" @click="handleGo(3)"
                  >成员管理</el-button
                >
                <el-button type="primary" @click="handleGo(4)"
                  >合作商家管理</el-button
                >
                <el-button type="primary" @click="handleGo(5)"
                  >混批管理</el-button
                >
                <el-button type="primary" @click="handleGo(6)"
                  >积分消费规则管理</el-button
                >
                <el-button type="primary" @click="handleGo(7)"
                  >业务通知管理设置</el-button
                >
                <el-button type="primary" @click="handleGo(8)"
                  >分销分润提现手续费设置</el-button
                >
                <el-button type="primary" @click="handleGo(9)"
                  >企业结算信息管理</el-button
                >
              </template>
              <el-button
                type="primary"
                @click="handleExit"
                v-if="userCompanyCard.roleid != 1"
                >退出企业</el-button
              >
            </div>
          </div>
        </template>
      </div>
      <div class="no_data" v-if="!userCompanyCard.id && isLoad">
        <el-button type="primary" @click="dialogCompanyEdit = true"
          >创建企业/团队名片</el-button
        >
        <el-button type="primary" @click="handleGo(1)"
          >加入企业or团队</el-button
        >
      </div>

      <!-- 企业信息编辑 start -->
      <el-dialog
        title="企业信息编辑"
        :close-on-click-modal="false"
        :visible.sync="dialogCompanyEdit"
        @close="handleCloseDialog(2)"
      >
        <div class="el-dialog-div">
          <el-form
            :model="formCompany"
            label-position="top"
            ref="formCompany"
            :rules="ruleFormDateCompanyEdit"
          >
            <el-form-item label="企业/团队名称" prop="qyname">
              <el-input
                v-model="formCompany.qyname"
                placeholder="请输入企业名称，30个字符内"
                maxlength="30"
                :readonly="
                  formCompany.qyname != '' && userCompanyCard.id ? true : false
                "
              ></el-input>
            </el-form-item>
            <el-form-item label="LOGO缩略图" prop="logo">
              <div class="upload_box" @mouseenter="creenIndex = 1">
                <!-- @mouseleave="creenIndex = ''" -->
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formCompany.logo" @mouseleave="creenIndex = ''">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="formCompany.logo"
                      fit="cover"
                    ></el-image>
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 1"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formCompany.logo)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formCompany.logo = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="企业/团队名称英文" prop="qyename">
              <el-input
                v-model="formCompany.qyename"
                placeholder="请输入企业名称英文或缩写，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系人" prop="linkname">
              <el-input
                v-model="formCompany.linkname"
                placeholder="请输入联系人名称，10个字符内"
                maxlength="10"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系电话" prop="linkphone">
              <el-input
                v-model="formCompany.linkphone"
                placeholder="请输入联系电话，20个字符内"
                maxlength="20"
              ></el-input>
            </el-form-item>
            <el-form-item label="联系邮箱" prop="linkemail">
              <el-input
                v-model="formCompany.linkemail"
                placeholder="请输入联系邮箱，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="所属行业">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label1_name"
                    @change="handleLabel1Change"
                    @focus="getQyFirstLevelLabel()"
                    placeholder="请选择一级行业标签"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in oneLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label2_name"
                    placeholder="请选择二级行业标签"
                    @focus="getQyTwoLevelLabel()"
                    @change="handleLabel2Change"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in twoLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="userCompanyCard.label3_name"
                    @change="handleLabel3Change"
                    @focus="getQyThreeLevelLabel()"
                    placeholder="请选择三级行业标签"
                  >
                    <el-option
                      :key="item.id"
                      :label="item.labelname"
                      :value="item.id"
                      v-for="item in threeLabelList"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="所在地">
              <el-row :gutter="20">
                <el-col :span="8">
                  <el-select
                    v-model="formCompany.province"
                    @change="handleProvinceChange"
                    placeholder="选择省/直辖市"
                  >
                    <el-option
                      :key="item.areaid"
                      :label="item.areaname"
                      :value="item.areaid"
                      v-for="item in provinceList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="formCompany.city"
                    placeholder="选择城市"
                    @visible-change="visibleCityChange"
                    @change="handleCityChange"
                  >
                    <el-option
                      :key="item.cityid"
                      :label="item.cityname"
                      :value="item.cityid"
                      v-for="item in cityList"
                    ></el-option>
                  </el-select>
                </el-col>
                <el-col :span="8">
                  <el-select
                    v-model="formCompany.area"
                    @change="handleAreaChange"
                    placeholder="选择所在区域"
                  >
                    <el-option
                      :key="item.addrid"
                      :label="item.addrname"
                      :value="item.addrid"
                      v-for="item in areaList"
                    ></el-option>
                  </el-select>
                </el-col>
              </el-row>
            </el-form-item>
            <el-form-item label="" prop="addr">
              <el-input
                type="textarea"
                v-model="formCompany.addr"
                placeholder="请输入详细地址"
              ></el-input>
            </el-form-item>
            <el-form-item label="社会统一信用代码" prop="uscc">
              <el-input
                v-model="formCompany.uscc"
                placeholder="请输入统一社会信用代码，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="营业执照副本副本扫描件" prop="logo">
              <div class="upload_box" @mouseenter="creenIndex = 2">
                <el-upload
                  action
                  list-type="picture-card"
                  :show-file-list="false"
                  :http-request="beforeAvatarUpload"
                >
                  <div v-if="formCompany.pic" @mouseleave="creenIndex = ''">
                    <el-image
                      style="width: 100%; height: 100%"
                      :src="formCompany.pic"
                      fit="cover"
                    ></el-image>
                    <div
                      class="el-upload-list__item-actions flex-rowc"
                      v-show="creenIndex == 2"
                    >
                      <span
                        @click.stop="handlePictureCardPreview(formCompany.pic)"
                        ><i class="iconfont icon-fangda"></i
                      ></span>
                      <span @click.stop="formCompany.pic = ''"
                        ><i class="iconfont icon-icon_shanchu-"></i
                      ></span>
                    </div>
                  </div>

                  <i v-else class="el-icon-plus avatar-uploader-icon"></i>
                </el-upload>
              </div>
            </el-form-item>
            <el-form-item label="官方抖音ID" prop="douyinid">
              <el-input
                v-model="formCompany.douyinid"
                placeholder="请输入官方抖音ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="官方小红书ID" prop="redbookid">
              <el-input
                v-model="formCompany.redbookid"
                placeholder="请输入官方小红书ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
            <el-form-item label="官方大众点评ID" prop="dianpingid">
              <el-input
                v-model="formCompany.dianpingid"
                placeholder="请输入官方大众点评ID，30个字符内"
                maxlength="30"
              ></el-input>
            </el-form-item>
          </el-form>
        </div>
        <div slot="footer" class="dialog-footer">
          <el-button size="medium" @click="handleCloseDialog(2)"
            >取 消</el-button
          >
          <el-button
            type="primary"
            size="medium"
            @click="handleCompanyEdit('formCompany')"
            >确 定</el-button
          >
        </div>
      </el-dialog>
      <!-- 企业信息编辑 end -->
    </div>
    <!-- 企业信息 end -->

    <!-- 放大图片 -->
    <el-dialog :visible.sync="dialogVisible">
      <img width="100%" height="100%" :src="dialogImageUrl" alt="" />
    </el-dialog>
  </div>
</template>
  <script>
import Clipboard from "clipboard";
import {
  getUserInfo,
  getProvince,
  getCity,
  getArea,
  encryptstringadd,
} from "../../api/api";
import { updateUserInfo } from "../../api/user";
import {
  getCompanyInfo,
  editCompany,
  getQyFirstLevelLabel,
  getQyTwoLevelLabel,
  getQyThreeLevelLabel,
  userExitCompany,
  getQyNoticeList,
  addQyNotice,
  editQyNotice,
} from "../../api/company";
import { getImageToken, uploadImageOss } from "../../utils/oss";
import { mapState } from "vuex";
export default {
  name: "userManagement",
  data() {
    var validateLinkname = (rule, value, callback) => {
      // 6-18位中英文、数字组合
      const regex = /^[a-zA-Z\u4e00-\u9fa5]+$/;
      if (value == "") {
        callback(new Error("请输入联系人名称，10个字符内"));
      } else if (!regex.test(value)) {
        callback(new Error("姓名格式错误，不能输入数字"));
      } else {
        callback();
      }
    };
    return {
      baseUrl: process.env.VUE_APP_IMG_BASE_API,
      PCA_address: "",
      userInfo: "",
      tuozhanInfo: "",
      dialogUserEdit: false,
      formDateUserEdit: {
        id: "",
        token: "",
        openid: "",
        username: "",
        email: "",
        userattr: "",
        qyname: "",
      },
      provinceList: [],
      cityList: [],
      areaList: [],
      ruleFormDateUserEdit: {
        truename: [{ required: true, message: "请输入姓名", trigger: "blur" }],
        email: [{ required: true, message: "请输入email", trigger: "blur" }],
        userattr: [
          { required: true, message: "请选择用户属性", trigger: "change" },
        ],
        qyname: [
          { required: true, message: "请输入企业名称", trigger: "blur" },
        ],
      },

      dialogCompanyEdit: false,
      isLoad: false,
      userCompanyCard: "",
      formCompany: {
        openid: "",
        qyname: "",
        qyename: "",
        logo: "",
        uscc: "",
        linkname: "",
        linkphone: "",
        linkemail: "",
        province: "",
        city: "",
        area: "",
        addr: "",
        label1: "",
        label2: "",
        label3: "",
        douyinid: "",
        redbookid: "",
        dianpingid: "",
        pic: "",
        poster_invite: "",
        poster_reg: "",
      },
      ruleFormDateCompanyEdit: {
        qyname: [
          {
            required: true,
            message: "请输入企业名称，30个字符内",
            trigger: "blur",
          },
        ],
        qyename: [
          {
            required: true,
            message: "请输入企业名称英文或缩写，30个字符内",
            trigger: "blur",
          },
        ],
        linkname: [{ validator: validateLinkname, trigger: "blur" }],
        // uscc: [
        //   {
        //     required: true,
        //     message: "请输入社会统一信用代码，30个字符内",
        //     trigger: "blur",
        //   },
        // ],
      },
      //   一级标签
      oneLabelList: [],
      //   二级标签
      twoLabelList: [],
      // 三级标签
      threeLabelList: [],
      creenIndex: "",
      dialogImageUrl: "",
      dialogVisible: false,

      noticeId: "",
      noticeObj: {
        mobile_user: "",
        mobile_cmuser: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      },

      countrysList: [], // 选中目前市场
      labelCmkeysList: [], // 选中商品关键字
    };
  },
  computed: {
    ...mapState(["OPENID", "USERINFO", "COUNTRY", "TOKEN"]),
  },
  created() {
    this.getInit();
    this.getCompanyInfo();
    this.getProvince();
  },
  methods: {
    async getInit() {
      // 获取用户
      let res1 = this.$store.state.USERINFO;
      this.userInfo = res1;

      this.formDateUserEdit.id = res1.id;
      this.formDateUserEdit.token = this.TOKEN;
      this.formDateUserEdit.openid = res1.openid ? res1.openid : "";
      this.formDateUserEdit.username = res1.username ? res1.username : "";
      this.formDateUserEdit.email = res1.email ? res1.email : "";
      this.formDateUserEdit.userattr = res1.userattr ? res1.userattr : "";
      this.formDateUserEdit.qyname = res1.qyname ? res1.qyname : "";
    },
    // 获取用户信息
    getUserInfo() {
      getUserInfo({
        token: this.TOKEN,
        countryid: this.COUNTRY.countryid,
      }).then((res) => {
        if (Object.keys(res).length > 0) {
          //如果country.countryid跟userInfo.ams_shop_exrate中的countryid值相等
          let exrateObj = res.ams_shop_exrate.filter(
            (item) => item.countryid == this.COUNTRY.countryid
          );

          //如果country.countryid跟userInfo.ams_shop_country中的countryid值相等
          let countryObj = res.ams_shop_country.filter(
            (item) => item.countryid == this.COUNTRY.countryid
          );

          // 合并exrateObj和countryObj为对象赋值给userInfo中新增键
          res.countryExrateObj = {
            ...exrateObj[0],
            ...countryObj[0],
          };
          this.$store.commit("updateUserInfo", res);
          this.getInit();
        }
      });
    },

    // 获取企业信息
    getCompanyInfo() {
      let openid = this.$store.state.OPENID;
      getCompanyInfo({ openid }).then((res) => {
        this.formCompany.openid = openid;
        if (!res.result) {
          this.userCompanyCard = res;
          this.formCompany.qyname = res.qyname ? res.qyname : "";
          this.formCompany.qyename = res.qyename;
          this.formCompany.logo = res.logo;
          this.formCompany.uscc = res.uscc;
          this.formCompany.linkname = res.linkname;
          this.formCompany.linkphone = res.linkphone;
          this.formCompany.linkemail = res.linkemail;
          this.formCompany.province = res.province ? Number(res.province) : "";
          this.formCompany.city = res.city ? Number(res.city) : "";
          this.formCompany.area = res.area ? Number(res.area) : "";
          this.formCompany.addr = res.addr;
          this.formCompany.label1 = res.label1;
          this.formCompany.label2 = res.label2;
          this.formCompany.label3 = res.label3;
          this.formCompany.douyinid = res.douyinid;
          this.formCompany.redbookid = res.redbookid;
          this.formCompany.dianpingid = res.dianpingid;
          this.formCompany.pic = res.pic;
          this.formCompany.poster_invite = res.poster_invite;
          this.formCompany.poster_reg = res.poster_reg;
          this.countrysList = res.countrys
            ? res.countrys.split(",").map(Number)
            : [];
          this.labelCmkeysList = res.label_cmkeys
            ? res.label_cmkeys.split(",").map(Number)
            : [];
        }
        this.isLoad = true;
      });
    },

    // 获取企业业务设置
    getQyNoticeList(isClick) {
      let qyguid = this.userCompanyCard.guid;
      getQyNoticeList({ qyguid }).then((res) => {
        if (res.total == 0) {
          this.addQyNotice();
        } else {
          let newRes = res.list.length > 0 ? res.list[0] : "";
          this.noticeId = newRes.id;
          this.noticeObj.mobile_user = newRes.mobile_user
            ? newRes.mobile_user
            : "";
          this.noticeObj.mobile_cmuser = newRes.mobile_cmuser
            ? newRes.mobile_cmuser
            : "";
          this.noticeObj.mobile_sendgoods = newRes.mobile_sendgoods
            ? newRes.mobile_sendgoods
            : "";
          this.noticeObj.mobile_checkreturn = newRes.mobile_checkreturn
            ? newRes.mobile_checkreturn
            : "";
          for (let key in this.noticeObj) {
            if (
              this.noticeObj[key] ===
              this.userInfo.truename + " | " + this.userInfo.mobile
            ) {
              this.noticeObj[key] = "";
            }
          }
          if (isClick) {
            this.encryptstringadd("serviceNitoceManage", {
              qyguid: this.userCompanyCard.guid,
              qyid: this.userCompanyCard.id,
              id: res.list[0].id,
            });
          } else {
            this.editQyNotice();
          }
        }
      });
    },

    // 新增企业业务设置
    addQyNotice() {
      let params = {
        qyguid: this.userCompanyCard.guid,
        mobile_user: "",
        mobile_sendgoods: "",
        mobile_checkreturn: "",
      };
      addQyNotice(params).then((res) => {
        if (res.result) {
          this.getQyNoticeList(true);
        }
      });
    },

    // 修改企业业务设置
    editQyNotice() {
      let { noticeObj } = this;
      let obj = {
        id: this.noticeId,
        qyguid: this.userCompanyCard.guid,
      };
      let mergedObj = { ...obj, ...noticeObj };
      editQyNotice(mergedObj).then((res) => {
        console.log(res, "--==--=");
        this.getCompanyInfo();
      });
    },

    // 获取城市
    getProvince() {
      getProvince().then((res) => {
        this.provinceList = res;
      });
    },
    // 获取城市
    getCity(data) {
      getCity(data).then((res) => {
        this.cityList = res;
      });
    },
    // 获取区域
    getArea(data) {
      getArea(data).then((res) => {
        this.areaList = res;
      });
    },

    // 获取企业一级标签
    getQyFirstLevelLabel() {
      getQyFirstLevelLabel().then((res) => {
        this.oneLabelList = res;
      });
    },
    // 获取二级标签
    getQyTwoLevelLabel() {
      getQyTwoLevelLabel(this.formCompany.label1).then((res) => {
        this.twoLabelList = res;
      });
    },
    // 获取三级标签
    getQyThreeLevelLabel() {
      getQyThreeLevelLabel(this.formCompany.label2).then((res) => {
        this.threeLabelList = res;
      });
    },

    // 关闭弹窗
    handleCloseDialog(type) {
      if (type == 1) {
        this.getUserInfo();
        this.dialogUserEdit = false;
      } else if (type == 2) {
        this.cityList = [];
        this.areaList = [];
        this.formCompany.province = "";
        this.formCompany.city = "";
        this.formCompany.area = "";
        this.getCompanyInfo();
        this.dialogCompanyEdit = false;
      }
    },
    // 显示弹窗
    handleShowDialog(type) {
      let { formCompany } = this;
      if (type == 1) {
        this.getUserInfo();
        this.dialogUserEdit = true;
      } else if (type == 2) {
        if (formCompany.province && formCompany.province != "") {
          this.getProvince();
          if (formCompany.city && formCompany.city != "") {
            this.getCity(formCompany.province);
            if (formCompany.area && formCompany.area != "") {
              this.getArea(formCompany.city);
            }
          }
        }
        this.getCompanyInfo();
        this.dialogCompanyEdit = true;
      }
    },
    // 下拉选择省市
    handleProvinceChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      // 个人地址
      if (dialogUserEdit) {
        this.formDateUserEdit.province = e;
        this.formDateUserEdit.city = "";
        this.userInfo.cityname = "";
        this.formDateUserEdit.area = "";
        this.userInfo.areaname = "";
      }
      // 企业地址
      if (dialogCompanyEdit) {
        this.formCompany.province = e;
        this.formCompany.city = "";
        this.userCompanyCard.cityname = "";
        this.formCompany.area = "";
        this.userCompanyCard.arearname = "";
      }

      this.getCity(e);
    },
    // 下拉选择城市
    handleCityChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      if (dialogUserEdit) {
        this.formDateUserEdit.city = e;
        this.formDateUserEdit.area = "";
        this.userInfo.areaname = "";
      }
      if (dialogCompanyEdit) {
        this.formCompany.city = e;
        this.formCompany.area = "";
        this.userCompanyCard.arearname = "";
      }

      this.getArea(e);
    },
    // 下拉选择区域
    handleAreaChange(e) {
      let { dialogCompanyEdit, dialogUserEdit } = this;
      if (dialogUserEdit) {
        this.formDateUserEdit.area = e;
      }
      if (dialogCompanyEdit) {
        this.formCompany.area = e;
      }
    },
    // 城市-下拉框出现时
    visibleCityChange() {
      let { cityList, dialogCompanyEdit, dialogUserEdit } = this;
      if (cityList.length == 0) {
        if (dialogCompanyEdit) {
          this.getCity(this.formCompany.province);
        }
        if (dialogUserEdit) {
          this.getCity(this.formDateUserEdit.province);
        }
      }
    },
    // 区域-下拉框出现时
    visibleAreaChange() {
      let { areaList, dialogCompanyEdit, dialogUserEdit } = this;
      if (areaList.length == 0) {
        if (dialogCompanyEdit) {
          this.getArea(this.formCompany.city);
        }
        if (dialogUserEdit) {
          this.getArea(this.formDateUserEdit.city);
        }
      }
    },

    // 修改个人数据
    async handleUserEdit() {
      let params = this.formDateUserEdit;
      let res1 = await updateUserInfo(params);
      if (res1.result) {
        this.$message.success(res1.message);
        this.getUserInfo();
        this.dialogUserEdit = false;
      } else {
        this.$message.error(res1.message);
        this.dialogUserEdit = false;
      }
    },

    // 一级标签
    handleLabel1Change(e) {
      this.formCompany.label1 = e;
      this.formCompany.label2 = "";
      this.formCompany.label3 = "";
    },
    handleLabel2Change(e) {
      this.formCompany.label2 = e;
      this.formCompany.label3 = "";
    },
    handleLabel3Change(e) {
      this.formCompany.label3 = e;
    },
    // 大图预览
    handlePictureCardPreview(url) {
      this.dialogImageUrl = url;
      this.dialogVisible = true;
    },

    async beforeAvatarUpload(e) {
      let { file } = e;
      const isJPG =
        file.type === "image/jpeg" ||
        file.type === "image/png" ||
        file.type === "image/jpg";
      if (!isJPG) {
        this.$message.error("缩略图只能是图片");
        return;
      }

      let { creenIndex } = this;
      const loading = this.$loading({
        lock: true,
        text: "上传中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });
      try {
        let { data } = await getImageToken(file.name);

        let { status } = await uploadImageOss(data, file);
        if (status == 200) {
          let url = data.host + "/" + data.key;
          if (creenIndex == 1) {
            this.formCompany.logo = url;
          } else if (creenIndex == 2) {
            this.formCompany.pic = url;
          }
          loading.close();
          this.creenIndex = "";
        }
      } catch (error) {
        loading.close();
        // console.error("Upload failed:", error);
      }
    },
    // 修改企业信息
    handleCompanyEdit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          let params = this.formCompany;
          editCompany(params).then((res) => {
            if (res.result) {
              this.$message.success(res.message);
              this.getCompanyInfo();
              this.dialogCompanyEdit = false;
            } else {
              this.$message.error(res.message);
              this.dialogCompanyEdit = false;
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleGo(type) {
      if (type == 1) {
        this.$router.push("/companyIndex/companyList");
      } else if (type == 2) {
        // this.$router.push(
        //   `/companyIndex/companyDetail/${this.userCompanyCard.id}`
        // );
        this.encryptstringadd("companyDetail", {
          qyid: this.userCompanyCard.id,
        });
      } else if (type == 3) {
        // this.$router.push(`/companyIndex/userList/${this.userCompanyCard.id}`);
        this.encryptstringadd("userList", { qyid: this.userCompanyCard.id });
      } else if (type == 4) {
        // this.$router.push(
        //   `/companyIndex/companyUserList/${this.userCompanyCard.id}`
        // );
        this.encryptstringadd("companyUserList", {
          qyid: this.userCompanyCard.id,
        });
      } else if (type == 5) {
        // this.$router.push(
        //   `/companyIndex/addRuleHPf/${this.userCompanyCard.id}`
        // );
        this.encryptstringadd("addRuleHPf", {
          qyguid: this.userCompanyCard.guid,
        });
      } else if (type == 6) {
        // this.$router.push(
        //   `/companyIndex/addRuleHPf/${this.userCompanyCard.id}`
        // );
        this.encryptstringadd("consumptionRule", {
          qyguid: this.userCompanyCard.guid,
        });
      } else if (type == 7) {
        // 先判断设置了企业业务
        this.getQyNoticeList(true);
      } else if (type == 8) {
        // this.$router.push(
        //   `/companyIndex/addRuleHPf/${this.userCompanyCard.id}`
        // );
        this.encryptstringadd("distributionWithdrawalFee", {
          qyguid: this.userCompanyCard.guid,
        });
      } else if (type == 9) {
        // this.$router.push(
        //   `/companyIndex/addRuleHPf/${this.userCompanyCard.id}`
        // );
        console.log(this.userCompanyCard.id, "====this.userCompanyCard.id");

        this.encryptstringadd("settlementManagement", {
          qyid: this.userCompanyCard.id,
        });
      }
    },

    // 页面跳转之前对参数进行加密
    async encryptstringadd(name, params) {
      if (params != "") {
        let paramsData = {
          openid: this.OPENID,
          jsondata: JSON.stringify(params),
        };
        const response = await encryptstringadd(paramsData);
        if (response.result) {
          this.$store.commit("cacheRoute", {
            encryptstring: response.encryptstring,
            name,
          });
          this.$router.push({
            name,
            params,
          });
          // window.open(this.$router.resolve({ name, params }).href, '_blank');
        }
      } else {
        this.$store.commit("cacheRoute", {
          encryptstring: "",
          name,
        });
        this.$router.push({
          name,
          params,
        });
      }
    },

    // 复制
    handleCopyBtn() {
      let clipboard = new Clipboard(".copy_box");
      clipboard.on("success", () => {
        // console.log("复制成功",e);
        this.$message.success("复制成功");
        // 释放内存
        clipboard.destroy();
      });
      clipboard.on("error", (e) => {
        // 不支持复制
        console.log("该浏览器不支持自动复制", e);
        if (e.text) {
          this.$message.warning("复制失败");
        } else {
          // this.$toast("暂无内容");
        }
        // 释放内存
        clipboard.destroy();
      });
    },

    // 退出企业
    handleExit() {
      this.loading = false;

      let openid = this.$store.state.OPENID;
      let { userCompanyCard } = this;
      let params = {
        qyid: userCompanyCard.id,
        openid,
      };
      userExitCompany(params).then((res) => {
        if (res.result) {
          this.loading = false;
          this.$message.success(res.message);
          this.getQyNoticeList(false);
        } else {
          this.loading = false;
          this.$message.error(res.message || "服务器报错，请稍后～");
        }
      });
    },
    userExitCompany() {},
  },
};
</script>
  <style lang="less" scoped>
.minePage {
  /deep/ .el-select {
    width: 100%;
  }
  .clumn_wrap {
    margin-bottom: 40px;
    .tit {
      font-size: 17px;
      margin-bottom: 15px;
      font-weight: bold;
      span {
        margin-left: 6px;
        cursor: pointer;
        .iconfont {
          font-size: 18px;
          font-weight: bold;
        }
      }
    }
    .clumn_main_wrap {
      padding: 20px;
      box-sizing: border-box;
      background: #fff;
    }
    &.clumn_wrap_poster {
      p {
        margin-bottom: 10px;
      }
      .img_box {
        width: 148px;
        height: 148px;
        img {
          width: auto;
          height: 100%;
        }
      }
    }
    .custom_checkbox {
      /deep/ .el-checkbox__label {
        color: #606266;
      }
      /deep/ .is-checked {
        .el-checkbox__label {
          color: #409eff;
        }
      }
    }
    /deep/ .el-button--primary {
      background: #000000;
      border: none;
    }
  }
  .el-dialog-div {
    height: 55vh;
    overflow-y: scroll;
    overflow-x: hidden;
  }
  .copy_wrap {
    position: relative;
    .copy_box {
      margin-left: 15px;
      cursor: pointer;
      position: absolute;
      right: -30px;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
</style>